import './Heropage.css';
import { useState, useEffect } from 'react';
import PersonImage from '../../assets/images/Images.svg';
import ArrowIcon from '../../assets/images/demobtn.svg';
import RelianceLogo from '../../assets/images/reliance.svg';
import RelianceJioLogo from '../../assets/images/jiologo1.svg';
import div1img from '../../assets/images/div1img.svg';
import d2i1 from '../../assets/images/d2i1.svg';
import d2i2 from '../../assets/images/d2i2.svg';
import d3i1 from '../../assets/images/d3i1.svg';
import d3i2 from '../../assets/images/d3i2.svg';
const Heropage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    // Trigger animations after component mounts
    const timer = setTimeout(() => {
      setIsLoaded(true);
    }, 100);

    return () => clearTimeout(timer);
  }, []);
  
  const handleContactus=()=>{
    window.open('https://forms.cloud.microsoft/r/R2gr83AJiL', '_blank');
    // window.location.href='https://forms.cloud.microsoft/r/R2gr83AJiL';
  }

  return (
    <div className="heropage">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content-container">
            <div className="hero-content">
              <h1 className={`hero-title ${isLoaded ? 'animate-title-slide' : ''}`}>
              Your All-in-One Platform for
              <br/>
               Smarter Asset Management.
              </h1>
              <p className={`hero-description ${isLoaded ? 'animate-text-slide delay-200' : ''}`}>
              Store, manage, and collaborate on assets effortlessly with our intelligent, secure and scalable DAM system.
              </p>
              <button className={`demo-btn ${isLoaded ? 'animate-button-slide delay-400' : ''}`} onClick={handleContactus}>
                Book A Demo
                <img src={ArrowIcon} alt="arrow" className="demo-arrow" />
              </button>
            </div>
          </div>
         <div className={`hero-mockups ${isLoaded ? 'animate-fade-scale delay-600' : ''}`}>
          <div className="div1">
            <img src={div1img} alt="div1" className={`${isLoaded ? 'animate-slide-bottom delay-800' : ''}`} />
          </div>
        <div className="div2">
          <img src={d2i1} alt="d2i1" className={`${isLoaded ? 'animate-slide-top delay-1000' : ''}`} />
          <img src={d2i2} alt="d2i2" className={`${isLoaded ? 'animate-slide-bottom delay-1200' : ''}`} />

        </div>
        <div className="div3">
          <img src={d3i1} alt="d3i1" className={`${isLoaded ? 'animate-slide-top delay-1000' : ''}`} />
          <img src={d3i2} alt="d3i2" className={`${isLoaded ? 'animate-slide-right delay-1200' : ''}`} />

        </div>
        </div>
        </div>
        {/* {isContactusOpen && <BookDemo isContactusOpen={isContactusOpen} setIsContactusOpen={setIsContactusOpen} />} */}
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-logos">
            <img
              src={RelianceLogo}
              alt="Reliance Logo"
              className="reliance-logo"
            />
            <img
              src={RelianceJioLogo}
              alt="Reliance Jio Logo"
              className="jio-logo"
            />
          </div>
        </div>
      </footer>
    </div>
  );
};

export default Heropage;
